import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const trust = [
  { icon: 'ri-shield-check-fill', label: 'Licensed & Insured', sub: 'Austin TX certified' },
  { icon: 'ri-star-fill', label: '5-Star Google Rating', sub: 'Verified reviews' },
  { icon: 'ri-tools-fill', label: 'Full-Service Provider', sub: 'Design → Build → Install' },
  { icon: 'ri-building-2-fill', label: 'Commercial Specialists', sub: 'All business types' },
  { icon: 'ri-time-fill', label: 'Fast Turnaround', sub: 'On-time delivery' },
  { icon: 'ri-map-pin-2-fill', label: 'Local Austin Experts', sub: 'We know city permits' },
];

const industries = ['Retail', 'Corporate', 'Industrial', 'Property Mgmt', 'Restaurants', 'Healthcare', 'Education', 'Hospitality'];

export default function TrustBar() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section ref={ref} className="bg-[#111111] border-b border-white/5">
      {/* Trust grid */}
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-white/5 reveal ${visible ? 'visible' : ''}`}>
          {trust.map((item, i) => (
            <div key={i} className="bg-[#111111] px-5 py-6 flex flex-col items-center text-center group hover:bg-[#191919] transition-colors">
              <span className={`w-9 h-9 flex items-center justify-center mb-3 delay-${i * 100}`}>
                <i className={`${item.icon} text-[#C4962A] text-lg`} />
              </span>
              <p className="text-white/80 text-xs font-bold uppercase tracking-wide mb-1">{item.label}</p>
              <p className="text-white/30 text-xs">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Industries strip */}
      <div className="border-t border-white/5 py-3 bg-[#0C0C0C]">
        <div className="max-w-7xl mx-auto px-8 flex items-center flex-wrap gap-x-8 gap-y-1 justify-center">
          <span className="eyebrow text-[#C4962A]/70 mr-2">Industries:</span>
          {industries.map((ind, i) => (
            <span key={ind} className="text-white/30 text-xs font-medium tracking-wide">
              {ind}
              {i < industries.length - 1 && <span className="text-[#C4962A]/30 ml-8">·</span>}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
